import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from '../components/common/Sidebar/Sidebar';
import Navbar from '../components/common/Navbar/Navbar';
import CounsellorProjects from '../pages/counsellor/CounsellorProjects';
import CounsellorReports from '../pages/counsellor/CounsellorReports';
import CounsellorOnboarding from '../pages/counsellor/CounsellorOnboarding';
import ProjectDetails from '../pages/common/ProjectDetails';
import styles from './Routes.module.css';

const CounsellorRoutes = () => {
  const menuItems = [
    { label: 'My Projects', path: '/counsellor/projects', icon: 'projects' },
    { label: 'Reports', path: '/counsellor/reports', icon: 'reports' }
  ];

  return (
    <div className={styles.layout}>
      <Sidebar menuItems={menuItems} role="counsellor" />
      <div className={styles.mainContent}>
        <Navbar title="COSMIC Counsellor" />
        <div className={styles.content}>
          <Routes>
            <Route path="onboarding" element={<CounsellorOnboarding />} />
            <Route path="projects" element={<CounsellorProjects />} />
            <Route path="projects/:projectId" element={<ProjectDetails />} />
            <Route path="reports" element={<CounsellorReports />} />
            <Route path="/" element={<Navigate to="projects" replace />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default CounsellorRoutes;

